import axiosInstance from '@/utils/api.js'

var state = {
  recurrentPayments: []
}

var getters = {
  RECURRENT_PAYMENTS: (state) => {
    return state.recurrentPayments
  }
}

var mutations = {
  SET_RECURRENT_PAYMENTS: (state, payload) => {
    state.recurrentPayments = payload
  }
}

var actions = {
  GET_RECURRENT_PAYMENTS: async (context, payload) => {
    let result = await axiosInstance.get('/users/recurrent_payments?user_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_RECURRENT_PAYMENTS', result.data)
    }
  },
  DELETE_RECURRENT_PAYMENTS: async (context, payload) => {
    return axiosInstance.delete('/users/recurrent_payments?user_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/payments.js